export default __webpack_public_path__ + "static/media/white_github.31617dfd.png";